import { validateNif } from "utils/validateNif";

export function useNifValidationError(nif: string) {
    const nifValidation = validateNif(nif.toLocaleUpperCase());
    return nif.length>0 && (typeof nifValidation != 'string' && !nifValidation);
}